import { createSlice } from "@reduxjs/toolkit"
import {
    getProgramListForUser,
    getSelectedProgram,
} from "../../utilities/accessLocalStorage"

const initialState = {
    notifications: [],
    rowsPerPage: 10,
    lastClick: new Date().getTime(),
    program: getSelectedProgram(),
    programListForUser: getProgramListForUser(),
    showSelectProgramModal: false,
    logoUrl: null,
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setNotifications: (state, action) => {
            state.notifications = action.payload
        },
        updateRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload
        },
        setLastClick: (state, action) => {
            state.lastClick = action.payload
        },
        updateProgram: (state, action) => {
            state.program = action.payload
        },
        updateProgramListForUser: (state, action) => {
            state.programListForUser = action.payload
        },
        setShowSelectProgramModal: (state, action) => {
            state.showSelectProgramModal = action.payload
        },
        updateLogo: (state, action) => {
            state.logoUrl = action.payload
        },
    },
})

export const {
    setNotifications,
    updateRowsPerPage,
    setLastClick,
    updateProgram,
    updateProgramListForUser,
    setShowSelectProgramModal,
    updateLogo,
} = userSlice.actions

export default userSlice.reducer
